import { dataAlignCenter } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAlignCenter = /*#__PURE__*/createIcon(dataAlignCenter)
export default IconAlignCenter
